module.exports = __webpack_public_path__ + "e1729a08e0b531cf36b5904d863c1025.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-6.png
// module id = 2237
// module chunks = 0